import React, { useContext } from 'react';
import classNames from 'classnames';
import SearchBar from '@fiverr-private/search_bar/src/components/SearchBar';
import { I18n, I18nProvider } from '@fiverr-private/fiverr_context';
import SafeComponent from '../../shared/SafeComponent';
import AppContext from '../../context/AppContext';
import Brand from '../Campaign/Brand';
import { getPopularSearch, getTagPath } from './utils';
import { reportBi, BI_TYPE_TAGS } from './config';

import './style.scss';

const Header = () => {
    const { displayBrandCampaign, displayNftSearch } = useContext(AppContext);

    return (
        <div className={classNames('header', {
            'display-brand-campaign': displayBrandCampaign
        })}>
            <h1 className="font-domaine">
                <I18n k="logged_out_homepage.hero.title" parseMarkup/>
            </h1>
            <I18nProvider>
                {({ i18n }) => (
                    <SearchBar placeholder={i18n.t('logged_out_homepage.hero.try_mobile_app')}
                        source="main_banner"/>
                )}
            </I18nProvider>
            {
                displayBrandCampaign && <Brand className="header-widget"/>
            }
            <div className="popular">
                <I18n k="logged_out_homepage.hero.popular"/>
                <ul>
                    {
                        getPopularSearch({ displayNftSearch }).map((item, index) => {
                            const pos = index + 1;
                            const tagPath = getTagPath(item, pos);

                            return (
                                <li key={item.name}>
                                    <a href={tagPath}
                                        className="text-body-2"
                                        onClick={() => reportBi(BI_TYPE_TAGS, { position: pos, ...item })}>
                                        <I18n k={`logged_out_homepage.hero.${item.name}`}/>
                                    </a>
                                </li>
                            );
                        })
                    }
                </ul>
            </div>
        </div>
    );
};

export { Header };
export default SafeComponent(Header);
